import { t } from '@hefe/i18n';
import {
  ResponseStripePostCheckout,
  StripePrice,
  StripeProduct,
} from '@hefe/models';
import { API } from '@hefe/store';
import { colors } from '@hefe/ui';
import { Button, Card, Space, Typography } from 'antd';
import { useMemo, useState } from 'react';
import { FaCheckCircle } from 'react-icons/fa';

interface ClubSubscriptionProductCardComponentProps {
  product: StripeProduct;
}

export default function ClubSubscriptionProductCardComponent(
  props: ClubSubscriptionProductCardComponentProps
) {
  const { product } = props;

  const [loading, setLoading] = useState(false);

  const monthlyPrice = useMemo(() => {
    const price = product?.prices?.find((price) => price.type === 'month');
    if (!price) {
      return product?.prices?.[0];
    }
    return price;
  }, [product]);

  const goToCheckout = (price: StripePrice) => {
    setLoading(true);
    API.stripe()
      .createCheckoutSession({
        price_id: price.id,
      })
      .then((session) => {
        // open session.url in new tab
        const response = session.data as ResponseStripePostCheckout;
        if (response.status === 'success') {
          window.open(response.url, '_blank');
        } else if (response.status === 'has_active_subscription') {
          window.open(response.url, '_blank');
        }
      })
      .finally(() => setLoading(false));
  };

  return (
    <Card title={product.name} bordered={false}>
      <Space direction="vertical" size={16}>
        <Space direction="vertical" size={16} style={{ marginBottom: 16 }}>
          {product?.prices.map((price) => {
            return (
              <Typography.Text strong style={{ fontSize: 16 }}>
                {t(
                  'subscriptions.price.' +
                    (price.type === 'year' ? 'per_year' : 'per_month'),
                  { amount: (price.unit_amount / 100).toFixed(2) }
                )}
              </Typography.Text>
            );
          })}
        </Space>
        <Typography.Text strong>{t('subscriptions.includes')}:</Typography.Text>
        <Space direction="vertical" size={8}>
          <Space direction="horizontal" size={8} align="center">
            <FaCheckCircle size={14} color={colors.primary} />
            <Typography.Text>
              {product?.limits?.users} {t('users.users')}
            </Typography.Text>
          </Space>
          <Space direction="horizontal" size={8} align="center">
            <FaCheckCircle size={14} color={colors.primary} />
            <Typography.Text>
              {product?.limits?.basketball_teams === 999
                ? 'Unbegrenzt'
                : product?.limits?.basketball_teams}{' '}
              {t('teams')}
            </Typography.Text>
          </Space>
          <Space direction="horizontal" size={8} align="center">
            <FaCheckCircle size={14} color={colors.primary} />
            <Typography.Text>
              {product?.limits?.tasks === 999
                ? 'Unbegrenzt'
                : product?.limits?.tasks}{' '}
              {t('tasks.plural')}
            </Typography.Text>
          </Space>
        </Space>
        <Button
          type="primary"
          block
          onClick={() => goToCheckout(monthlyPrice)}
          loading={loading}
        >
          {t('select')}
        </Button>
      </Space>
    </Card>
  );
}
